import { useEffect, useState, useCallback } from 'react';

/**
 * Toggle Tabela/Cards com persistência por chave + força "cards" em mobile.
 *
 * @param {string} storageKey  chave única por tela (ex.: "view:clientes")
 * @param {'cards'|'tabela'} initial valor padrão (default 'tabela' — desktop)
 * @returns {{ mode: 'cards'|'tabela', setMode: Fn, isMobile: boolean, effective: 'cards'|'tabela' }}
 */
export default function useViewMode(storageKey, initial = 'tabela') {
  const [mode, setModeState] = useState(() => {
    if (typeof window === 'undefined') return initial;
    return localStorage.getItem(storageKey) || initial;
  });
  const [isMobile, setIsMobile] = useState(() => {
    if (typeof window === 'undefined') return false;
    return window.matchMedia('(max-width: 640px)').matches;
  });

  useEffect(() => {
    const mq = window.matchMedia('(max-width: 640px)');
    const handler = (e) => setIsMobile(e.matches);
    mq.addEventListener('change', handler);
    return () => mq.removeEventListener('change', handler);
  }, []);

  const setMode = useCallback((next) => {
    setModeState(next);
    try { localStorage.setItem(storageKey, next); } catch {}
  }, [storageKey]);

  // Em mobile sempre cards; modo permanece guardado para quando voltar pro desktop.
  const effective = isMobile ? 'cards' : mode;
  return { mode, setMode, isMobile, effective };
}
